import { useEffect } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Pages from "@client.enums/pages";
import { useSelector } from "react-redux";
import { makeProfile } from "@client.pages/Login/reducer";

const DashboardPage = () => {
  const [setTopBarTitle] = useOutletContext();
  const { t } = useTranslation();
  const navigation = useNavigate();
  const profile = useSelector(makeProfile);

  useEffect(() => {
    setTopBarTitle(t("components.NavigationBar.dashboard"));
    navigation(Pages.DashboardInsights);
  }, [t, setTopBarTitle, navigation, profile]);

  return null;
};

export default DashboardPage;
